import script from "./SiteSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteSettings.vue?vue&type=script&setup=true&lang=js"

import "./SiteSettings.vue?vue&type=style&index=0&id=610a4a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610a4a20"]])

export default __exports__